import moment from 'moment'

import CommonUtils from '@/utils/commonUtils'

import {HygieneService} from '../services/HygieneService'
import CronUtils from '../utils/cronUtils'

import {contexts} from './context'

export const state = {
  viviers: [],
  cuissons: [],
  tailleReglementaire: [],
  cuissonsByDate: [],
  viviersByDate: [],
  preparationsByDate: [],
  temperaturesByDate: [],
  nettoyagesByTimestamp: [],
  temperaturesRulesByTimestamp: [],
  conditionnements: [],
  temperaturesFurnituresByTimestamp: [],
  preparations: [],
  temperatures: [],
  nettoyages: [],
  nettoyagesByDate: [],
  nettoyagesByDateForPrint: [],
  receptions: [],
  audits: [],
  auditsByDate: [],
  receptionsByDate: [],
  congelations: [],
  congelationsByDate: [],
  calibrages: [],
  calibragesByDate: [],
  fraicheurs: [],
  fraicheursByDate: [],
  fumaisons: [],
  barquettes: [],
  maturations: [],
  barquettesByDate: [],
  maturationsByDate: [],
  fumaisonsByDate: [],
  parasitismes: [],
  parasitismesByDate: [],
  expeditions: [],
  expeditionsByDate: [],
  glacages: [],
  glacagesByDate: [],
  tailleReglementaireByDate: [],
  print: [],
  nettoyageSign: [],
  temperatureSign: [],
  date: moment().format('YYYY-MM-DD'),
  month: moment().format('YYYY-MM'),
  selectedRecord: {},
  conditionnementsVente: [],
  dialog: false,
  loading: false,
  loadingCount: 0
}

export const mutations = {
  setHygieneLoading(currentState, isLoading) {
    if (isLoading) {
      currentState.hygiene.loadingCount += 1
    } else {
      currentState.hygiene.loadingCount = Math.max(0, currentState.hygiene.loadingCount - 1)
    }
    currentState.hygiene.loading = currentState.hygiene.loadingCount > 0
  },
  setDialogStatus(currentState, bool) {
    currentState.hygiene.dialog = bool
  },
  setPrintRecords(currentState, records) {
    currentState.hygiene.print = records
  },
  resetValues(currentState, values) {
    currentState.hygiene.viviers = values
    currentState.hygiene.cuissons = values
    currentState.hygiene.tailleReglementaire = values
    currentState.hygiene.cuissonsByDate = values
    currentState.hygiene.viviersByDate = values
    currentState.hygiene.preparationsByDate = values
    currentState.hygiene.temperaturesByDate = values
    currentState.hygiene.nettoyagesByTimestamp = values
    currentState.hygiene.temperaturesRulesByTimestamp = values
    currentState.hygiene.conditionnements = values
    currentState.hygiene.temperaturesFurnituresByTimestamp = values
    currentState.hygiene.preparations = values
    currentState.hygiene.temperatures = values
    currentState.hygiene.nettoyages = values
    currentState.hygiene.nettoyagesByDate = values
    currentState.hygiene.nettoyagesByDateForPrint = values
    currentState.hygiene.receptions = values
    currentState.hygiene.audits = values
    currentState.hygiene.auditsByDate = values
    currentState.hygiene.receptionsByDate = values
    currentState.hygiene.congelations = values
    currentState.hygiene.congelationsByDate = values
    currentState.hygiene.calibrages = values
    currentState.hygiene.calibragesByDate = values
    currentState.hygiene.fumaisons = values
    currentState.hygiene.fumaisonsByDate = values
    currentState.hygiene.parasitismes = values
    currentState.hygiene.parasitismesByDate = values
    currentState.hygiene.expeditions = values
    currentState.hygiene.expeditionsByDate = values
    currentState.hygiene.glacages = values
    currentState.hygiene.glacagesByDate = values
    currentState.hygiene.tailleReglementaireByDate = values
    currentState.hygiene.fraicheurs = values
    currentState.hygiene.fraicheursByDate = values
    currentState.hygiene.loadingCount = 0
    currentState.hygiene.loading = false
  },
  setCurrentRecord(currentState, record) {
    if (!state.loading) {
      currentState.hygiene.selectedRecord = record
    }
  },
  setCuissons(currentState, cuissons) {
    currentState.hygiene.cuissons = Array.isArray(cuissons.cuissons) ? cuissons.cuissons : []
  },
  setCuissonsByDate(currentState, cuissons) {
    currentState.hygiene.cuissonsByDate = Array.isArray(cuissons.cuissons) ? cuissons.cuissons : []
  },
  setTailleReglementaireByDate(currentState, tailleReglementaire) {
    currentState.hygiene.tailleReglementaireByDate = Array.isArray(tailleReglementaire.tailleReglementaire)
      ? tailleReglementaire.tailleReglementaire
      : []
  },
  setViviersByDate(currentState, viviers) {
    currentState.hygiene.viviersByDate = Array.isArray(viviers.viviers) ? viviers.viviers : []
  },
  setViviers(currentState, viviers) {
    currentState.hygiene.viviers = Array.isArray(viviers.viviers) ? viviers.viviers : []
  },
  setAuditsByDate(currentState, audits) {
    currentState.hygiene.auditsByDate = Array.isArray(audits.audits) ? audits.audits : []
  },
  setAudits(currentState, audits) {
    currentState.hygiene.audits = Array.isArray(audits.audits) ? audits.audits : []
  },
  setTemperatures(currentState, temperatures) {
    currentState.hygiene.temperatures = Array.isArray(temperatures.temperatures) ? temperatures.temperatures : []
  },
  setTemperaturesByDate(currentState, temperatures) {
    currentState.hygiene.temperaturesByDate = Array.isArray(temperatures.temperatures) ? temperatures.temperatures : []
  },
  setNettoyages(currentState, nettoyages) {
    currentState.hygiene.nettoyages = Array.isArray(nettoyages.nettoyages) ? nettoyages.nettoyages : []
  },
  setNettoyagesByDate(currentState, nettoyages) {
    currentState.hygiene.nettoyagesByDate = Array.isArray(nettoyages.nettoyages) ? nettoyages.nettoyages : []
  },
  setNettoyagesByDateForPrint(currentState, nettoyages) {
    currentState.hygiene.nettoyagesByDateForPrint = Array.isArray(nettoyages.nettoyages) ? nettoyages.nettoyages : []
  },
  setNettoyagesByTimestamp(currentState, nettoyages) {
    currentState.hygiene.nettoyagesByTimestamp = nettoyages
  },
  setTemperaturesRulesByTimestamp(currentState, temperatures) {
    currentState.hygiene.temperaturesRulesByTimestamp = temperatures
  },
  setConditionnementsTemp(currentState, conditionnements) {
    currentState.hygiene.conditionnements = Array.isArray(conditionnements.conditionnements)
      ? conditionnements.conditionnements
      : []
  },
  setTemperaturesFurnituresByTimestamp(currentState, temperatures) {
    currentState.hygiene.temperaturesFurnituresByTimestamp = temperatures
  },
  setTailleReglementaire(currentState, tailleReglementaire) {
    currentState.hygiene.tailleReglementaire = Array.isArray(tailleReglementaire.tailleReglementaire)
      ? tailleReglementaire.tailleReglementaire
      : []
  },
  setHygieneDate(currentState, date) {
    currentState.hygiene.date = date
  },
  setHygieneMonth(currentState, month) {
    currentState.hygiene.month = month
  },
  setPreparationsByDate(currentState, preparations) {
    currentState.hygiene.preparationsByDate = Array.isArray(preparations.preparations) ? preparations.preparations : []
  },
  setPreparations(currentState, {preparations}) {
    currentState.hygiene.preparations = Array.isArray(preparations)
      ? preparations
      : Array.isArray(preparations?.preparations)
        ? preparations.preparations
        : []
  },
  setReceptionsByDate(currentState, receptions) {
    currentState.hygiene.receptionsByDate = Array.isArray(receptions.receptions) ? receptions.receptions : []
  },
  setReceptions(currentState, receptions) {
    currentState.hygiene.receptions = Array.isArray(receptions.receptions) ? receptions.receptions : []
  },
  setBarquettesByDate(currentState, barquettes) {
    currentState.hygiene.barquettesByDate = Array.isArray(barquettes.barquettes) ? barquettes.barquettes : []
  },
  setBarquettes(currentState, barquettes) {
    currentState.hygiene.barquettes = Array.isArray(barquettes.barquettes) ? barquettes.barquettes : []
  },
  setFraicheursByDate(currentState, fraicheurs) {
    currentState.hygiene.fraicheursByDate = Array.isArray(fraicheurs.fraicheurs) ? fraicheurs.fraicheurs : []
  },
  setFraicheurs(currentState, fraicheurs) {
    currentState.hygiene.fraicheurs = Array.isArray(fraicheurs.fraicheurs) ? fraicheurs.fraicheurs : []
  },
  setMaturationsByDate(currentState, maturations) {
    currentState.hygiene.maturationsByDate = Array.isArray(maturations.maturations) ? maturations.maturations : []
  },
  setMaturations(currentState, maturations) {
    currentState.hygiene.maturations = Array.isArray(maturations.maturations) ? maturations.maturations : []
  },
  setCongelationsByDate(currentState, congelations) {
    currentState.hygiene.congelationsByDate = Array.isArray(congelations.congelations) ? congelations.congelations : []
  },
  setCongelations(currentState, congelations) {
    currentState.hygiene.congelations = Array.isArray(congelations.congelations) ? congelations.congelations : []
  },
  setCalibragesByDate(currentState, calibrages) {
    currentState.hygiene.calibragesByDate = Array.isArray(calibrages.calibrages) ? calibrages.calibrages : []
  },
  setCalibrages(currentState, {calibrages}) {
    currentState.hygiene.calibrages = Array.isArray(calibrages) ? calibrages : []
  },
  setFumaisonsByDate(currentState, fumaisons) {
    currentState.hygiene.fumaisonsByDate = Array.isArray(fumaisons.fumaisons) ? fumaisons.fumaisons : []
  },
  setFumaisons(currentState, fumaisons) {
    currentState.hygiene.fumaisons = Array.isArray(fumaisons.fumaisons) ? fumaisons.fumaisons : []
  },
  setParasitismesByDate(currentState, parasitismes) {
    currentState.hygiene.parasitismesByDate = Array.isArray(parasitismes.parasitismes) ? parasitismes.parasitismes : []
  },
  setParasitismes(currentState, parasitismes) {
    currentState.hygiene.parasitismes = Array.isArray(parasitismes.parasitismes) ? parasitismes.parasitismes : []
  },
  setExpeditionsByDate(currentState, expeditions) {
    currentState.hygiene.expeditionsByDate = Array.isArray(expeditions.expeditions) ? expeditions.expeditions : []
  },
  setExpeditions(currentState, expeditions) {
    currentState.hygiene.expeditions = Array.isArray(expeditions.expeditions) ? expeditions.expeditions : []
  },
  setGlacagesByDate(currentState, glacages) {
    currentState.hygiene.glacagesByDate = Array.isArray(glacages.glacages) ? glacages.glacages : []
  },
  setGlacages(currentState, glacages) {
    currentState.hygiene.glacages = Array.isArray(glacages.glacages) ? glacages.glacages : []
  },
  setNettoyageSign(currentState, signs) {
    currentState.hygiene.nettoyageSign = signs.signs
  },
  setTemperatureSign(currentState, signs) {
    currentState.hygiene.temperatureSign = signs.signs
  },
  setPreparationsConditionnements(currentState, conditionnements) {
    currentState.hygiene.conditionnementsVente = conditionnements
  }
}

export const actions = {
  loadNettoyageSign({commit}, date) {
    HygieneService.getNettoyageSign(date).then(signs => {
      commit('setNettoyageSign', {signs})
    })
  },
  loadTemperatureSign({commit}, date) {
    HygieneService.getTemperatureSign(date).then(signs => {
      commit('setTemperatureSign', {signs})
    })
  },
  removeCurrentRecord({commit}) {
    commit('setCurrentRecord', {})
  },
  resetValues({commit}) {
    commit('resetValues', [])
  },
  setHygieneDate({commit}, date) {
    commit('setHygieneDate', date)
  },
  setHygieneMonth({commit}, month) {
    commit('setHygieneMonth', month)
  },
  toggleDialog({commit}, bool) {
    commit('setDialogStatus', bool)
  },
  printNettoyage({commit}, records) {
    commit('setPrintRecords', records)
  },
  loadPreparationsByDate({commit, rootState}) {
    commit('setHygieneLoading', true)
    HygieneService.getPreparationsByDate(rootState.context.currentContext, rootState.hygiene.date).then(
      preparations => {
        commit('setHygieneLoading', false)
        commit('setPreparationsConditionnements', preparations.conditionnements)
        commit('setPreparationsByDate', preparations)
      }
    )
  },
  loadViviersByDate({commit, rootState}) {
    commit('setHygieneLoading', true)
    HygieneService.getViviersByDate(rootState.hygiene.date).then(viviers => {
      commit('setHygieneLoading', false)
      commit('setViviersByDate', {viviers})
    })
  },
  loadCuissonsByDate({commit, rootState}) {
    commit('setHygieneLoading', true)
    HygieneService.getCuissonsByDate(rootState.hygiene.date).then(cuissons => {
      commit('setHygieneLoading', false)
      commit('setCuissonsByDate', {cuissons})
    })
  },
  loadCuissonByUuid({commit}, uuid) {
    commit('setHygieneLoading', true)
    HygieneService.getCuissonsByUuid(uuid).then(cuissons => {
      commit('setHygieneLoading', false)
      const record = {
        color: 'orange',
        logo: 'cuisson.png',
        record: cuissons[0],
        component: 'recordCuisson'
      }
      commit('setCurrentRecord', record)
    })
  },
  loadPreparationByUuid({commit}, uuid) {
    commit('setHygieneLoading', true)
    HygieneService.getPreparationsByUuid(uuid).then(preparations => {
      commit('setHygieneLoading', false)
      const record = {
        color: 'red',
        logo: 'preparation.png',
        record: preparations[0],
        component: 'recordPreparations'
      }
      commit('setCurrentRecord', record)
    })
  },
  loadTailleReglementaireByDate({commit, rootState}) {
    commit('setHygieneLoading', true)
    HygieneService.getTailleReglementaireByDate(rootState.hygiene.date).then(tailleReglementaire => {
      commit('setHygieneLoading', false)
      commit('setTailleReglementaireByDate', {tailleReglementaire})
    })
  },
  loadTemperaturesByDate({commit, rootState}) {
    commit('setHygieneLoading', true)
    HygieneService.getTemperaturesByDate(rootState.hygiene.date, rootState.context.currentContext).then(
      temperatures => {
        commit('setHygieneLoading', false)
        commit('setTemperaturesByDate', {temperatures})
      }
    )
  },
  loadNettoyagesByDate({commit, rootState}) {
    commit('setHygieneLoading', true)
    HygieneService.getNettoyagesByDate(rootState.hygiene.date, rootState.context.currentContext).then(nettoyages => {
      commit('setHygieneLoading', false)
      commit('setNettoyagesByDate', {nettoyages})
    })
  },
  loadNettoyagesByDateForPrint({commit, rootState}) {
    commit('setHygieneLoading', true)
    HygieneService.getNettoyagesByDateForPrint(rootState.hygiene.date).then(nettoyages => {
      commit('setHygieneLoading', false)
      commit('setNettoyagesByDateForPrint', {nettoyages})
    })
  },
  loadAllNettoyagesByTimestamp({rootState, commit}, month) {
    commit('setHygieneLoading', true)
    const monthMoment = moment(month, 'YYYY-MM')
    const dateDebut = monthMoment.startOf('month').format('YYYY-MM-DD')
    const dateFin = monthMoment.endOf('month').endOf('isoWeek').format('YYYY-MM-DD')
    HygieneService.getNettoyagesByTimestamp(rootState.context.currentContext, dateDebut, dateFin).then(nettoyages => {
      const emplacements = nettoyages
        .filter(d => d.inMonth !== false)
        .reduce((acc, datedElement) => {
          const newEmplacements = datedElement.cleanings.filter(
            emplacement =>
              !acc.find(savedEmplacement => savedEmplacement.idEmplacementRayon === emplacement.idEmplacementRayon)
          )
          return [...acc, ...newEmplacements]
        }, [])

      const emplacementsWithElements = emplacements.map(emplacement => ({
        ...emplacement,
        elements: nettoyages.reduce((acc, datedEmplacements) => {
          const foundedEmplacement = datedEmplacements.cleanings.find(
            datedEmplacement => datedEmplacement.idEmplacementRayon === emplacement.idEmplacementRayon
          )
          const newElements = foundedEmplacement.elements
            .filter(
              sourceElement =>
                !acc.find(
                  savedElement =>
                    savedElement.idEmplacementRayon === sourceElement.idEmplacementRayon &&
                    savedElement.idElementRayonCatalog === sourceElement.idElementRayonCatalog
                )
            )
            .map(element => ({
              nom: element.nom,
              idEmplacementRayon: element.idEmplacementRayon,
              idElementRayonCatalog: element.idElementRayonCatalog,
              cron: CronUtils.toSmallText(element.cron),
              cronValue: element.cron,
              emp: element.text,
              color: element.color
            }))
          return [...acc, ...newElements]
        }, [])
      }))

      const emplacementsWithCleaning = emplacementsWithElements.map(emplacement => ({
        ...emplacement,
        elements: emplacement.elements.map(element => ({
          ...element,

          cleanings: nettoyages
            .filter(d => d.inMonth !== false)
            .map(dated => {
              const foundedEmplacement = dated.cleanings.find(
                datedEmplacement => datedEmplacement.idEmplacementRayon === emplacement.idEmplacementRayon
              )
              const allMatching =
                foundedEmplacement?.elements.filter(
                  e =>
                    e.idElementRayonCatalog === element.idElementRayonCatalog &&
                    e.idEmplacementRayon === element.idEmplacementRayon
                ) || []

              // 🟡 Utiliser le premier si besoin pour clean / employé / color
              const clean = allMatching[0]
              if (clean === undefined) {
                return {
                  date: dated.date,
                  clean: 2,
                  employe: clean ? clean.employe : '',
                  color: clean ? clean.color : 'gray',
                  closed: clean ? clean.closed : null,
                  enregistrements: allMatching
                }
              }
              if (clean.clean === false) {
                return {
                  date: dated.date,
                  clean: 0,
                  employe: clean ? clean.employe : '',
                  color: clean ? clean.color : 'gray',
                  closed: clean.closed,
                  enregistrements: allMatching
                }
              }
              if (clean.clean === true) {
                return {
                  date: dated.date,
                  clean: 1,
                  employe: clean ? clean.employe : '',
                  color: clean ? clean.color : 'gray',
                  closed: clean.closed,
                  enregistrements: allMatching
                }
              }
            })
        }))
      }))
      commit('setHygieneLoading', false)
      const emplacementsWithCleaningSorted = emplacementsWithCleaning
        .sort((emp1, emp2) => emp2.elements.length - emp1.elements.length)
        .filter(emp => emp.elements.length != 0)
      commit('setNettoyagesByTimestamp', {emplacementsWithCleaningSorted})
    })
  },
  loadAllTemperaturesRulesByTimestamp({commit, rootState}, month) {
    if (rootState.context.currentContext === contexts.BOUCHERIE_CONTEXT) {
      commit('setConditionnementsTemp', {conditionnements: []})
      commit('setTemperaturesRulesByTimestamp', {temperatures: []})
    } else {
      commit('setHygieneLoading', true)
      const dateDebut = moment(month, 'YYYY-MM').format('YYYY-MM-01')
      const dateFin = moment(month, 'YYYY-MM').format('YYYY-MM-') + moment(month, 'YYYY-MM').daysInMonth()
      HygieneService.getTemperaturesRulesByTimestamp(dateDebut, dateFin)
        .then(values => {
          commit('setHygieneLoading', false)
          commit('setConditionnementsTemp', {conditionnements: values.conditionnements})
          commit('setTemperaturesRulesByTimestamp', {
            temperatures: values.temperatures.map(rule => ({
              ...rule,
              cron: CronUtils.toSmallText(rule.cron)
            }))
          })
        })
        .catch(err => console.error('err', err))
    }
  },
  loadAllTemperaturesFurnituresByTimestamp({commit, rootState}, month) {
    commit('setHygieneLoading', true)
    const dateDebut = moment(month, 'YYYY-MM').format('YYYY-MM-01')
    const dateFin = moment(month, 'YYYY-MM').format('YYYY-MM-') + moment(month, 'YYYY-MM').daysInMonth()
    HygieneService.getTemperaturesFurnituresByTimestamp(rootState.context.currentContext, dateDebut, dateFin)
      .then(temperatures => {
        commit('setHygieneLoading', false)
        commit('setTemperaturesFurnituresByTimestamp', {
          temperatures: temperatures.map(temperature => ({
            ...temperature,
            active: CommonUtils.toBoolean(temperature.active),
            cron: CronUtils.toSmallText(temperature.cron)
          }))
        })
      })
      .catch(err => console.error('err', err))
  },
  loadReceptionsByDate({commit, rootState}) {
    commit('setHygieneLoading', true)
    HygieneService.getReceptionsByDate(rootState.context.currentContext, rootState.hygiene.date).then(receptions => {
      commit('setHygieneLoading', false)
      commit('setReceptionsByDate', {receptions})
    })
  },
  loadBarquettesByDate({commit, rootState}) {
    commit('setHygieneLoading', true)
    HygieneService.getBarquettesByDate(rootState.context.currentContext, rootState.hygiene.date).then(barquettes => {
      commit('setHygieneLoading', false)
      commit('setBarquettesByDate', {barquettes})
    })
  },
  loadMaturationsByDate({commit, rootState}) {
    commit('setHygieneLoading', true)
    HygieneService.getMaturationsByDate(rootState.context.currentContext, rootState.hygiene.date).then(maturations => {
      commit('setHygieneLoading', false)
      commit('setMaturationsByDate', {maturations})
    })
  },

  loadCongelationsByDate({commit, rootState}) {
    commit('setHygieneLoading', true)
    HygieneService.getCongelationsByDate(rootState.hygiene.date).then(congelations => {
      commit('setHygieneLoading', false)
      commit('setCongelationsByDate', {congelations})
    })
  },
  loadCalibragesByDate({commit, rootState}) {
    commit('setHygieneLoading', true)
    HygieneService.getCalibragesByDate(rootState.context.currentContext, rootState.hygiene.date).then(calibrages => {
      commit('setHygieneLoading', false)
      commit('setCalibragesByDate', {calibrages})
    })
  },
  loadAuditsByDate({commit, rootState}) {
    commit('setHygieneLoading', true)
    HygieneService.getAuditsByDate(rootState.hygiene.date).then(audits => {
      commit('setHygieneLoading', false)
      commit('setAuditsByDate', {audits})
    })
  },
  loadFraicheursByDate({commit, rootState}) {
    commit('setHygieneLoading', true)
    HygieneService.getFraicheursByDate(rootState.hygiene.date).then(fraicheurs => {
      commit('setHygieneLoading', false)
      commit('setFraicheursByDate', {fraicheurs})
    })
  },
  loadFumaisonsByDate({commit, rootState}) {
    commit('setHygieneLoading', true)
    HygieneService.getFumaisonsByDate(rootState.hygiene.date).then(fumaisons => {
      commit('setHygieneLoading', false)
      commit('setFumaisonsByDate', {fumaisons})
    })
  },
  loadParasitismesByDate({commit, rootState}) {
    commit('setHygieneLoading', true)
    HygieneService.getParasitismesByDate(rootState.hygiene.date).then(parasitismes => {
      commit('setHygieneLoading', false)
      commit('setParasitismesByDate', {parasitismes})
    })
  },
  loadExpeditionsByDate({commit, rootState}) {
    commit('setHygieneLoading', true)
    HygieneService.getExpeditionsByDate(rootState.hygiene.date).then(expeditions => {
      commit('setHygieneLoading', false)
      commit('setExpeditionsByDate', {expeditions})
    })
  },
  loadGlacagesByDate({commit, rootState}) {
    commit('setHygieneLoading', true)
    HygieneService.getGlacagesByDate(rootState.hygiene.date).then(glacages => {
      commit('setHygieneLoading', false)
      commit('setGlacagesByDate', {glacages})
    })
  },
  loadViviers({commit, rootState}) {
    commit('setHygieneLoading', true)
    HygieneService.getViviersBy3Months(rootState.hygiene.month).then(viviers => {
      commit('setHygieneLoading', false)
      commit('setViviers', {viviers})
    })
  },
  loadPreparations({commit, rootState}) {
    commit('setHygieneLoading', true)
    HygieneService.getPreparationsBy3Months(rootState.context.currentContext, rootState.hygiene.month).then(
      preparations => {
        commit('setHygieneLoading', false)
        commit('setPreparations', {preparations})
      }
    )
  },
  loadTailleReglementaire({commit, rootState}) {
    commit('setHygieneLoading', true)
    HygieneService.getTailleReglementaireBy3Months(rootState.hygiene.month).then(tailleReglementaire => {
      commit('setHygieneLoading', false)
      commit('setTailleReglementaire', {tailleReglementaire})
    })
  },
  loadCuissons({commit, rootState}) {
    commit('setHygieneLoading', true)
    HygieneService.getCuissonsBy3Months(rootState.hygiene.month).then(cuissons => {
      commit('setHygieneLoading', false)
      commit('setCuissons', {cuissons})
    })
  },
  loadTemperatures({commit, rootState}) {
    commit('setHygieneLoading', true)
    HygieneService.getTemperaturesBy3Months(rootState.context.currentContext, rootState.hygiene.month).then(
      temperatures => {
        commit('setHygieneLoading', false)
        commit('setTemperatures', {temperatures})
      }
    )
  },
  loadNettoyages({commit, rootState}) {
    commit('setHygieneLoading', true)
    HygieneService.getNettoyagesBy3Months(rootState.context.currentContext, rootState.hygiene.month).then(
      nettoyages => {
        commit('setHygieneLoading', false)
        commit('setNettoyages', {nettoyages})
      }
    )
  },
  loadReceptions({commit, rootState}) {
    commit('setHygieneLoading', true)
    HygieneService.getReceptionsBy3Months(rootState.context.currentContext, rootState.hygiene.month).then(
      receptions => {
        commit('setHygieneLoading', false)
        commit('setReceptions', {receptions})
      }
    )
  },
  loadAudits({commit, rootState}) {
    commit('setHygieneLoading', true)
    HygieneService.getAuditsBy3Months(rootState.hygiene.month).then(audits => {
      commit('setHygieneLoading', false)
      commit('setAudits', {audits})
    })
  },
  loadFraicheurs({commit, rootState}) {
    commit('setHygieneLoading', true)
    HygieneService.getFraicheursBy3Months(rootState.hygiene.month).then(fraicheurs => {
      commit('setHygieneLoading', false)
      commit('setFraicheurs', {fraicheurs})
    })
  },
  loadCongelations({commit, rootState}) {
    commit('setHygieneLoading', true)
    HygieneService.getCongelationsBy3Months(rootState.hygiene.month).then(congelations => {
      commit('setHygieneLoading', false)
      commit('setCongelations', {congelations})
    })
  },
  loadCalibrages({commit, rootState}) {
    commit('setHygieneLoading', true)
    HygieneService.getCalibragesBy3Months(rootState.context.currentContext, rootState.hygiene.month).then(
      calibrages => {
        commit('setHygieneLoading', false)
        commit('setCalibrages', {calibrages})
      }
    )
  },

  loadMaturations({commit, rootState}) {
    commit('setHygieneLoading', true)
    HygieneService.getMaturationsBy3Months(rootState.context.currentContext, rootState.hygiene.month).then(
      maturations => {
        commit('setHygieneLoading', false)
        commit('setMaturations', {maturations})
      }
    )
  },
  loadBarquettes({commit, rootState}) {
    commit('setHygieneLoading', true)
    HygieneService.getBarquettesBy3Months(rootState.context.currentContext, rootState.hygiene.month).then(
      barquettes => {
        commit('setHygieneLoading', false)
        commit('setBarquettes', {barquettes})
      }
    )
  },

  loadFumaisons({commit, rootState}) {
    commit('setHygieneLoading', true)
    HygieneService.getFumaisonsBy3Months(rootState.hygiene.month).then(fumaisons => {
      commit('setHygieneLoading', false)
      commit('setFumaisons', {fumaisons})
    })
  },
  loadParasitismes({commit, rootState}) {
    commit('setHygieneLoading', true)
    HygieneService.getParasitismesBy3Months(rootState.hygiene.month).then(parasitismes => {
      commit('setHygieneLoading', false)
      commit('setParasitismes', {parasitismes})
    })
  },
  loadExpeditions({commit, rootState}) {
    commit('setHygieneLoading', true)
    HygieneService.getExpeditionsBy3Months(rootState.hygiene.month).then(expeditions => {
      commit('setHygieneLoading', false)
      commit('setExpeditions', {expeditions})
    })
  },
  loadGlacages({commit, rootState}) {
    commit('setHygieneLoading', true)
    HygieneService.getGlacagesBy3Months(rootState.hygiene.month).then(glacages => {
      commit('setHygieneLoading', false)
      commit('setGlacages', {glacages})
    })
  }
}
export default {state, actions, mutations}
